import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './translations/en.json';
import es from './translations/es.json';

// Add more languages as you create the translation files
// import zh from './translations/zh.json';
// import hi from './translations/hi.json';
// import tl from './translations/tl.json';
// import pt from './translations/pt.json';

i18n
  .use(LanguageDetector) // Automatically detect browser language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es }
      // Add more languages here:
      // zh: { translation: zh },
      // hi: { translation: hi },
      // tl: { translation: tl },
      // pt: { translation: pt }
    },
    fallbackLng: 'en', // Default language if detection fails
    interpolation: {
      escapeValue: false // React already protects from XSS
    },
    detection: {
      // Order of language detection
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Cache user language preference
      caches: ['localStorage']
    }
  });

export default i18n;
